import { formatBDT } from "utils/formatPrice"
import { formatReadableDate } from "utils/formatDate"
import { EmployeeLink } from "../EmployeeLink"

const FuelPurchaseInfoCell = ({ data = {} }) => {
  const { fuel_type, fuel_qty, fuel_price, purchaser, fuel_station, purchase_date, remarks } = data ?? {}

  const qty = parseFloat(fuel_qty ?? 0)
  const price = parseFloat(fuel_price ?? 0)
  const perLiter = qty > 0 ? (price / qty).toFixed(2) : "-"

  return (
    <div className="text-dark">
      <div className="d-flex align-items-center mb-1">
        <i className="bx bx-gas-pump me-2 text-warning"></i>
        <span>
          <strong>{qty.toFixed(2)} L</strong> of <strong>{fuel_type?.name ?? "-"}</strong>
        </span>
      </div>

      <div className="mb-1">
        <i className="bx bx-user me-2 text-primary"></i>
        Purchased by: <EmployeeLink name={purchaser?.name} username={purchaser?.user?.username}/>
      </div>

      <div className="mb-1">
        <i className="bx bx-building-house me-2 text-info"></i>
        Fuel Station: <strong>{fuel_station?.name ?? "-"}</strong>
      </div>

      <div className="mb-1">
        <i className="bx bx-calendar me-2 text-secondary"></i>
        Purchase Date: <strong>{purchase_date ? formatReadableDate(purchase_date) : "-"}</strong>
      </div>

      <div className="mb-1">
        <i className="bx bx-money me-2 text-success"></i>
        Total Price: <strong>{formatBDT(price)}</strong>{" "}
        {qty > 0 && <small className="text-muted">({perLiter} BDT/L)</small>}
      </div>

      {remarks && (
        <div>
          <i className="bx bx-note me-2 text-muted"></i>
          Remarks: <strong>{remarks}</strong>
        </div>
      )}
    </div>
  )
}

export default FuelPurchaseInfoCell
